import React from 'react';
import '../styles/Modal.css';

function FeedbackModal({
  title,
  message,
  onConfirm,
  confirmLabel = 'Ok',
  onCancel,
  cancelLabel = 'Annuleren'
}) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div className="modal-box">
        {title && <h2 id="modal-title">{title}</h2>}
        <p>{message}</p>
        <div className="modal-actions">
          {onCancel && (
            <button type="button" className="modal-btn modal-btn-secondary" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button type="button" className="modal-btn modal-btn-primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeedbackModal;
